import React, { useState } from "react";
import Input from "../Input";

const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter);
  const onChange = (e) => {
    setValue(e.target.value);
    setFilter(e.target.value || undefined);
  };
  return (
    <div>
      <Input
        value={value || ""}
        onChange={onChange}
        placeholder="search..."
        className="border-slate-300 dark:border-slate-700 rounded-md hover:border-slate-600 dark:hover:border-slate-600 focus:border-slate-500 dark:focus:border-slate-600 p-2"
      />
    </div>
  );
};

export default GlobalFilter;
